(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-information"]) return;
  try {
    
// Spironik — фикс сбора variant_id и product_id (надёжные фолбэки)
if (!window.__spironikOptionTrackingInit) {
  window.__spironikOptionTrackingInit = true;

  const getVariantId = (root) => {
    // 1) стандартное скрытое поле варианта
    const byHidden = root?.querySelector('input[name="id"]')?.value;
    if (byHidden) return byHidden;

    // 2) выбранная радиокнопка с data-variant-id
    const byRadio = root?.querySelector('input[type="radio"][data-variant-id]:checked')?.dataset.variantId;
    if (byRadio) return byRadio;

    // 3) выбранная <option selected> с data-variant-id
    const byOption = root?.querySelector('select option:checked[data-variant-id]')?.dataset.variantId;
    if (byOption) return byOption;

    // 4) глобальный Shopify объект (часто присутствует)
    const byGlobal = window.ShopifyAnalytics?.meta?.selectedVariantId
                  || window.Shopify?.Analytics?.meta?.selectedVariantId;
    if (byGlobal) return byGlobal;

    return null;
  };

  const getProductId = (el) => {
    // 1) ближайшая форма с атрибутом data-product-id
    const byFormAttr = el.closest('form')?.dataset?.productId;
    if (byFormAttr) return byFormAttr;

    // 2) любой ближайший ancestor с data-product-id (например, обёртка блока)
    const byAncestor = el.closest('[data-product-id]')?.dataset?.productId;
    if (byAncestor) return byAncestor;

    // 3) из глобального ShopifyAnalytics
    const byGlobal = window.ShopifyAnalytics?.meta?.product?.id
                  || window.Shopify?.Analytics?.meta?.product?.id;
    if (byGlobal) return byGlobal;

    return null;
  };

  const getProductTitle = (el) => {
    const byFormAttr = el.closest('form')?.dataset?.productTitle;
    if (byFormAttr) return byFormAttr;

    const byAncestor = el.closest('[data-product-title]')?.dataset?.productTitle;
    if (byAncestor) return byAncestor;

    const byH1 = document.querySelector('h1')?.innerText;
    if (byH1) return byH1;

    return document.title;
  };

  const publish = (name, value, el) => {
    try {
      const form = el.closest('form') || document;
      const payload = {
        option_name:   name,
        option_value:  value,
        variant_id:    getVariantId(form),
        product_id:    getProductId(el),
        product_title: getProductTitle(el),
        currency:      window.Shopify?.currency?.active,
        url:           location.href,
        timestamp:     Date.now()
      };

      if (window.Shopify?.analytics?.publish) {
        Shopify.analytics.publish('spironik_option_select', payload);
      }
    } catch (e) {}
  };

  // клики по label/кнопкам с нашими атрибутами
  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-swatch-option]');
    if (!el) return;
    publish(el.dataset.swatchOption, el.dataset.swatchValue ?? el.value, el);
  }, true);

  // изменения в select/radio вида options[...]
  document.addEventListener('change', (e) => {
    const input = e.target;
    if (input.matches('input[type="radio"][name^="options["], select[name^="options["]')) {
      const m = input.name.match(/^options\[(.+)\]$/);
      if (m) publish(m[1], input.value, input);
    }
  }, true);
}

  } catch(e) { console.error(e); }
})();
})();
